import React, { useEffect, useState } from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import ReactConfetti from "react-confetti";
import useSound from "use-sound";
// STYLES
import { DialogWrapper } from "./ResetCrosswordModal.style";
// HELPERS
import { Api } from "Helpers";
// SOUND
import ApplauseSound from "Assets/Sounds/Common/Applause.mp3";

const ResetCrosswordModal = (props) => {
	const location = useLocation();

	const [loading, setLoading] = useState(false);

	const subjects = useSelector((state) => state.Auth.subjectAccessList);
	const subjectId = subjects?.filter((item) => item.subject === "English")[0].subjectId;

	const [playApplause, { stop: stopApplauseSound }] = useSound(ApplauseSound, { volume: 0.2 });

	useEffect(() => {
		if (props.open) playApplause();
	}, [props.open, playApplause]);

	useEffect(() => {
		return function cleanup() {
			stopApplauseSound();
		};
	}, [stopApplauseSound]);

	const resetCrossWord = async () => {
		setLoading(true);

		const response = await new Api().get("crossword/crossword-data ");

		if (response.status === 200) {
			const data = response.data;
			const payloadStorage = { crossWordData: "", crossWordTitleId: data?.crossWordTitleId };

			const storageResponse = new Api().post("crossword/crossword-data", { data: payloadStorage });
			const resetResponse = new Api().put("crossword/reset-crossword-puzzle", { params: { crossWordTitleId: data?.crossWordTitleId } });

			await Promise.all([resetResponse, storageResponse]);
		}

		setLoading(false);
		props.handleClose();

		window.location.reload(true);
	};

	return (
		<DialogWrapper open={props.open}>
			<ReactConfetti className="confetti" numberOfPieces={500} recycle={false} run={props.open} />

			<div className="main-container">
				{loading ? (
					<CircularProgress />
				) : (
					<>
						<div className="text">Are you sure you want to reset crossword ?</div>

						<div className="flex">
							<div className={`btn-container  enable green`}>
								<Button className={`done-btn  enable green`} onClick={props.handleClose}>
									Cancel
								</Button>
							</div>

							<div className={`btn-container  enable green`}>
								<Button className={`done-btn  enable green`} onClick={resetCrossWord}>
									Okay
								</Button>
							</div>
						</div>
					</>
				)}
			</div>
		</DialogWrapper>
	);
};

export default ResetCrosswordModal;
